(function () {
  // Lê de --bp-mobile (sass/base/global.scss), única fonte compartilhada com o SCSS
  var MOBILE_BP = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--bp-mobile'), 10) || 768;

  function initSmsBlock(block) {
    var stage = block.querySelector('.sms-stage');
    var track = block.querySelector('.sms-phone__track');
    var slides = block.querySelectorAll('.sms-phone__slide');
    var count = slides.length;
    if (!track || !stage || count < 1) return;

    var dots = block.querySelectorAll('.sms-nav__dot');
    var prevBtn = block.querySelector('.sms-nav__arrow--prev');
    var nextBtn = block.querySelector('.sms-nav__arrow--next');
    var current = 0;
    var isDesktop = false;
    var animating = false;

    function isMobile() {
      return window.innerWidth < MOBILE_BP;
    }

    function getStep() {
      var postW = slides[0].offsetWidth;
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      return postW + gap;
    }

    function updateNav() {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === current);
      });
      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current === count - 1;
    }

    function slideTo(index) {
      if (index < 0 || index >= count || index === current) return;
      if (animating) return;
      animating = true;
      current = index;
      var step = getStep();
      gsap.to(track, {
        x: -current * step,
        duration: 0.4,
        ease: 'power2.out',
        overwrite: true,
        onComplete: function () { animating = false; }
      });
      updateNav();
    }

    // ─── Mobile: go to slide ───
    function goTo(index, instant) {
      if (index < 0 || index >= count) return;
      current = index;
      track.style.transition = instant ? 'none' : 'transform 0.4s cubic-bezier(0.5,0,0,1)';
      track.style.transform = 'translateX(' + (-current * 100) + '%)';
      updateNav();
    }

    // ─── Nav buttons ───
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (isDesktop) slideTo(current - 1);
        else goTo(current - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (isDesktop) slideTo(current + 1);
        else goTo(current + 1);
      });
    }
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.dataset.index, 10);
        if (isDesktop) slideTo(idx);
        else goTo(idx);
      });
    });

    // ─── Touch swipe (mobile) ───
    var startX = 0;
    var dragging = false;

    track.addEventListener('touchstart', function (e) {
      if (!isMobile()) return;
      startX = e.touches[0].clientX;
      dragging = true;
      track.style.transition = 'none';
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      if (!dragging || !isMobile()) return;
      var dx = e.touches[0].clientX - startX;
      var offset = -current * 100 + (dx / track.parentElement.offsetWidth) * 100;
      track.style.transform = 'translateX(' + offset + '%)';
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      if (!dragging || !isMobile()) return;
      dragging = false;
      var dx = e.changedTouches[0].clientX - startX;
      var threshold = track.parentElement.offsetWidth * 0.2;
      if (dx < -threshold && current < count - 1) goTo(current + 1);
      else if (dx > threshold && current > 0) goTo(current - 1);
      else goTo(current);
    });

    // ─── Desktop: wheel on stage only ───
    function isStageVisible() {
      var rect = stage.getBoundingClientRect();
      var vh = window.innerHeight;
      var visibleH = Math.min(rect.bottom, vh) - Math.max(rect.top, 0);
      return visibleH >= rect.height * 0.8;
    }

    function onStageWheel(e) {
      if (!isDesktop || animating) return;
      if (!isStageVisible()) return;

      var delta = e.deltaY;
      if (Math.abs(delta) < 2) return;

      if (delta > 0 && current < count - 1) {
        e.preventDefault();
        e.stopPropagation();
        slideTo(current + 1);
      } else if (delta < 0 && current > 0) {
        e.preventDefault();
        e.stopPropagation();
        slideTo(current - 1);
      }
    }

    function initDesktop() {
      if (typeof gsap === 'undefined') return;
      if (isDesktop) return;
      if (count < 2) return;

      isDesktop = true;
      current = 0;
      track.style.cssText = '';
      gsap.set(track, { x: 0 });
      updateNav();

      stage.addEventListener('wheel', onStageWheel, { passive: false });
    }

    function killDesktop() {
      isDesktop = false;
      stage.removeEventListener('wheel', onStageWheel);
      gsap.set(track, { clearProps: 'x' });
    }

    function handleResize() {
      if (isMobile()) {
        if (isDesktop) killDesktop();
        goTo(current);
      } else {
        if (!isDesktop) initDesktop();
      }
    }

    // ─── Keyboard ───
    block.setAttribute('tabindex', '0');
    block.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault();
        if (isDesktop) slideTo(current + 1);
        else goTo(current + 1);
      }
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault();
        if (isDesktop) slideTo(current - 1);
        else goTo(current - 1);
      }
    });

    // ─── Init ───
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(handleResize, 150);
    });

    updateNav();
    handleResize();
  }

  document.querySelectorAll('.sms-block').forEach(initSmsBlock);
})();
